<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">
    <!--<div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-8px  padding-bottom padding-top-5">
      Services Configuration
    </div>-->



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed border-right2 padding-right-0px">
        <div class="card height-600px">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light">
            <div class="row margin-top10px margin-left-20px card-title-schedule-bb" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">

              <label class="wh-header font-weight-normal card-title-schedule-bl2 border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                {{l.DisplayName}}
              </label>
              <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                 ><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

            </div>



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light">
            <div class="row" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class="offset-md-2 col-md-3">
                <img class="img-circle-50 margin-left-10px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">
              </div>
            </div>
            
            <div class="row" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class=" col-md-11 text-align-center">
                <label class="font-size-13px margin-bottom-0px">{{l.FormattedCode}}</label>
              </div>
            </div>

            <div class="row" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class="col-md-11 text-align-center">
                <label class="font-size-13px margin-bottom-0px">{{l.Age}},{{l.Gender}}</label>
              </div>
            </div>
            <div class="row border-bottom-light margin-right-0px margin-left-0px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <!--<div class="col-md-3">
                <label>Phone Number:</label>
              </div>-->
              <div class="col-md-11 text-align-center">
                <label class="margin-bottom-0px font-size-13px">{{l.Telephone1}}</label>
              </div>
            </div>
            <div class="row border-bottom  rowfor margin-left-zero margin-right-0px nav-link-hand padding-all-5px" (click)="ShowPalnDetails(p)" *ngFor="let p of CurrentCounsellingPlanController">
              <div class="col-md-10">
                <div class="row  margin-left-zero color-Assign" >
                  <!--<i class="fa fa-check" *ngIf="p.PlanStatus=='Active'"></i>-->
                  <a class="nav-link-hand margin-left-5px font-size-14">{{p.TreatmentPlan}}</a>
                </div>
                <div class="row">
                  <label class="margin-left-20p font-size-11px margin-bottom-0px">{{p.StartDate| date:'dd-MMM-yyyy'}}</label>
                </div>

              </div>
              <div class="col-md-2">
                <i class="fa fa-check tick-mark-styles" *ngIf="p.PlanStatus=='Active'"></i>
              </div>
              
            </div>
            <div>

            </div>

          </div>

        </div>
      </div>

      <div class="offset-md-2 col-md-6 padding-left-29px margin-top17px padding-right-5px">
     
          <div class="card">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                  <div class="card-header wh-header card-title-schedule-bl2 font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb">
                    <div class="row" >
                      <div class="col-md-4">


                        Review Activities
                      </div>
                      <div class="col-md-8">
                        <div class="row" *ngIf="Selectedplan">
                          <div class="offset-md-3 col-md-6 text-align-right padding-right-7px">
                            <label class="margin-bottom-0px font-size-15px font-weight-bold">Branch</label>
                          </div>:
                          <div class="col-md-2 padding-right-0px padding-left-10px">
                            <label class="margin-bottom-0px font-size-15px ">{{Selectedplan.FacilityShortName}}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                  <div class="card-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">

                    <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px" *ngIf="Selectedplan">
                      <div class="col-md-2 border-right-1px padding-right-0px">
                        <div></div>
                        <div class="text-align-center margin-top-13px"><label class="margin-bottom-0px font-size-16px color-Assign">{{Selectedplan.TreatmentPlan}}</label></div>
                      </div>
                      <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                        <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Start Date</label></div>
                        <div><label class="margin-bottom-0px font-size-14">{{Selectedplan.StartDate|date:'dd-MMM-yyyy'}}</label></div>
                      </div>
                      <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                        <div><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px">Package Cost</label></div>
                        <div><label class="margin-bottom-0px font-size-14">{{Selectedplan.PackageCost}}</label></div>
                      </div>
                      <div class="col-md-2 border-right-1px padding-right-0px">

                        <div class="margin-top-13px"><label class="margin-bottom-0px font-size-14">{{Selectedplan.FinancialStatus}}</label></div>
                      </div>
                      <div class="col-md-2 border-right-1px padding-right-0px">
                        <div class="text-align-center margin-top-13px"><label class="margin-bottom-0px font-size-14"><i class="fa fa-check margin-right-3px color-Assign" *ngIf="Selectedplan.PlanStatus=='Active'"></i>{{Selectedplan.PlanStatus}}</label></div>
                      </div>
                      <div class="col-md-2  padding-right-0px">

                        <div class="text-align-center margin-top-13px">
                          <a (click)="Viewplan()" class="nav-link-hand" title="View Plan">
                            <span class="badge"><i class="fa fa-info-circle font-size-16px"></i></span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt padding-left-5px" data-ps-id="dfsfsde">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component">
                            <div class="table-responsive overflow-x">


                              <table class="table table-striped margin-left-zero"
                                     cols="auto,2*,*,*,*,*,*,*">

                                <thead class="">
                                  <tr>

                                    <th class="">
                                      Schedule Date
                                    </th>
                                    <!--<th class="text-align-center">Day</th>-->

                                    <th class="">
                                      Follow up
                                    </th>
                                    <th class="">
                                      Remarks
                                    </th>
                                    <th>Actual Date</th>

                                    <!--<th class="text-align-center">Start Time</th>-->
                                    <th class="">
                                      Status
                                    </th>

                                    <th class="">

                                    </th>




                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let l of CurrentCounsellingActivitiesByTimeController">



                                    <td class="padding-right-0px td-padding-tb ">

                                      <div [ngSwitch]="l.FollowupStatus">
                                        <!--<div *ngSwitchCase="''">
    <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
  </div>-->
                                        <div *ngSwitchCase="'Scheduled'" class="td-border-8px-green">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Rescheduled'" class="td-brorder-8px-blue">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Discussed'" class="td-brorder-8px-blue">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>

                                        <div *ngSwitchCase="'Cancelled'" class="td-border-8px-red">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase="'No Answer'" class="td-border-8px-red">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Not Reachable'" class="td-border-8px-red">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Completed'" class="td-border-8px-green">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Overdue'" class="td-border-8px-Black">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase=" " class="">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color  margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                      </div>

                                    </td>
                                    <td class="text-align-center td-padding-tb">
                                      <div [ngSwitch]="l.FollowupMode">
                                        <div *ngSwitchCase="'Email'" class="">
                                          <i class="fa fa-envelope "></i>
                                        </div>
                                        <div *ngSwitchCase="'Phone'" class="">
                                          <i class="fas fa-mobile-alt"></i>
                                        </div>
                                        <div *ngSwitchCase="'Visit'" class="">
                                          <i class="fa fa-handshake"></i>
                                        </div>
                                        <div *ngSwitchCase="'Other'" class="">
                                          <label>{{l.FollowupMode}}</label>
                                        </div>
                                      </div>

                                    </td>
                                    <!--<td class="">{{l.FollowupMode}}</td>-->
                                    <!--<td class="td-padding text-align-center"></td>-->
                                    <td class="td-padding-tb td-elipsis">{{l.Remarks}}</td>
                                    <td class="td-padding-tb">{{l.ActualActivityDate| date:'MMM-dd-yyyy'}}</td>
                                    <td class="td-padding-tb padding-right-0px">
                                      <div [ngSwitch]="l.FollowupStatus">
                                        <div *ngSwitchCase="'Scheduled'" class="">
                                          <i class="fa fa-check color-green"></i>
                                          {{l.FollowupStatus}}
                                        </div>
                                        <div *ngSwitchCase="'Completed'" class="">
                                          <i class="fa fa-check color-green"></i>
                                          {{l.FollowupStatus}}
                                        </div>
                                        <div *ngSwitchCase="'ReScheduled'" class="">
                                          <label>{{l.FollowupStatus}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Overdue'" class="">
                                          <label>{{l.FollowupStatus}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Not Reachable'" class="">
                                          <label>{{l.FollowupStatus}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Not Answer'" class="">
                                          <label>{{l.FollowupStatus}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Discussed'" class="">
                                          <label>{{l.FollowupStatus}}</label>
                                        </div>
                                        <div *ngSwitchCase="'Cancelled'" class="">
                                          <label>{{l.FollowupStatus}}</label>
                                        </div>
                                      </div>
                                    </td>



                                    <td class="td-padding-tb">
                                      <div class="row margin-left-auto">
                                        <a (click)="edit(l)" class="nav-link-hand education-navlink" title="Edit">
                                          <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                        </a>

                                      </div>
                                    </td>



                                  </tr>

                                </tbody>

                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
              </div>

            </div>


          </div>


      


      </div>

      <div class=" col-md-4 padding-left-0px">

        <div class="card position-fixed-activity affix my-profile-form">
          <div class="card-header wh-header card-title-schedule-bl2 font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb">
            New Activity
          </div>
          <div class="card-body margin-left-zero padding-left-0px padding-right-0px">
         
            <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Schedule Date</label>
                    </div>


                    <div class="col-md-6">
                      <div class="date-form">
                        <input class="form-control" placeholder="Start Date"
                               name="dp" [(ngModel)]="ScheduleDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required >
                        <small class="form-text text-danger"
                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>


                        </a>

                      </div>

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Schedule Time</label>
                    </div>


                    <div class="col-md-6">
                      <input type="time" class="form-control" id="CurrentSaveCounsellingActivityRequest.ActivityTime" placeholder="Schedule Time"
                             [(ngModel)]="CurrentSaveCounsellingActivityRequest.ActivityTime"
                             name="CurrentSaveCounsellingActivityRequest.ActivityTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Follow-up Mode</label>
                    </div>


                    <div class="col-md-6">
                      <CodeTypeValue CodeType="FWUM"
                                     id="CurrentSaveCounsellingActivityRequest.FollowupMode"
                                     [(ngModel)]="CurrentSaveCounsellingActivityRequest.FollowupMode" SelectedValue=""
                                     name="CurrentSaveCounsellingActivityRequest.FollowupMode" required >
                      </CodeTypeValue>
                        

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                    </div>

                    <div class="col-md-6">
                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                name="CurrentSaveCounsellingActivityRequest.Remarks"
                                [(ngModel)]="CurrentSaveCounsellingActivityRequest.Remarks" required  minlength="1" maxlength="100"
                                #addconcerns_text="ngModel"></textarea>
                      <small class="form-text text-danger"
                             *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                    
                    </div>
                  </div>


                </div>
              </div>
              <div class="row">
                <!--<button type="submit"  *ngIf='!isRequesting' class="btn font-size-13px actions-btn-prime margin-left-auto margin-right-auto">Save</button>-->
                <button type="submit"  *ngIf='!isRequesting' class="btn font-size-13px actions-btn-prime margin-left-auto margin-right-auto">Save</button>
              </div>
              </form>
          </div>

        </div>

      </div>

    </div>
  </div>

</div>


